import { englishMessages } from 'admin-on-rest';

import customDutchMessages from './nl';
import customEnglishMessages from './en';

export default {
    nl: { ...customDutchMessages },
    en: { ...englishMessages, ...customEnglishMessages },
};


// WEBPACK FOOTER //
// ./src/i18n/index.js